import {Controller, FieldValues} from 'react-hook-form'

import {useFormInputLabelWithSuffix} from '../../hooks'
import {ControlledFormField} from '../../types'
import {BaseTextField} from '../formFields'

type TextFieldProps<TField extends FieldValues> = ControlledFormField<TField> & {
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  fullWidth?: boolean
  shouldUnregister?: boolean
}

export const TextField = <TField extends FieldValues>({
  label,
  name,
  control,
  disabled,
  readOnly,
  helperText,
  optional,
  onChange,
  fullWidth,
  shouldUnregister
}: TextFieldProps<TField>) => {
  const inputLabel = useFormInputLabelWithSuffix({label, optional})

  return (
    <Controller
      name={name}
      disabled={disabled || readOnly}
      control={control}
      shouldUnregister={shouldUnregister}
      render={({field: {ref, ...field}, fieldState}) => (
        <BaseTextField
          fullWidth={fullWidth}
          {...field}
          inputRef={ref}
          disabled={disabled}
          InputProps={{
            readOnly
          }}
          label={inputLabel}
          onChange={(e) => {
            field.onChange(e)
            onChange?.(e)
          }}
          error={fieldState.invalid}
          helperText={fieldState.error?.message ?? helperText}
          inputProps={{
            'data-test-id': `text-field-${name}`
          }}
        />
      )}
    />
  )
}
